module.exports = __webpack_public_path__ + "img/title.10cd8c57.png";